import React, { Component } from "react";
import Select from "react-select";

// Components
import GeneralLoader from "../../../GeneralLoader";
import ErrorWrap from "../../../utils/error-success/ErrorWrap";

class LocationFieldset extends Component {
	constructor(props) {
		super(props);

		this.dataProps = ["address", "address_2", "city", "postal", "province"];
		this.miscProps = ["errors", "locationsError", "locationsLoading", "provinces", "inProcess"];
	}

	shouldComponentUpdate(nextProps) {
		// Check local props to see if any have changed
		const dataPropResults = this.dataProps.some(prop => {
			return this.props.data[prop] !== nextProps.data[prop];
		});
		const miscPropResults = this.miscProps.some(prop => {
			return this.props[prop] !== nextProps[prop];
		});

		// If any local props changed, we will rerender
		return dataPropResults || miscPropResults;
	}

	render() {
		const { data, errors, locationsError, locationsLoading, provinces, inProcess } = this.props;

		return (
			<div className="fieldset">
				<div className="title-label">Location</div>

				<div className="fieldset-indent">
					<div className="form-field">
						<label>Address:</label>

						{!!errors.address && <ErrorWrap animate={1}>{errors.address}</ErrorWrap>}
						<input
							type="text"
							id="address"
							value={data.address}
							maxLength="255"
							disabled={inProcess}
							onKeyPress={e => this.props.handleKeyPress(e)}
							onChange={e => this.props.handleInputChange(e)}
						/>
					</div>

					<div className="form-field">
						<label>Address 2:</label>

						{!!errors.address_2 && <ErrorWrap animate={1}>{errors.address_2}</ErrorWrap>}
						<input
							type="text"
							id="address_2"
							value={data.address_2}
							maxLength="255"
							disabled={inProcess}
							onKeyPress={e => this.props.handleKeyPress(e)}
							onChange={e => this.props.handleInputChange(e)}
						/>
					</div>

					<div className="floated-field-container">
						<div className="form-field half-field">
							<label>City:</label>

							{!!errors.city && <ErrorWrap animate={1}>{errors.city}</ErrorWrap>}
							<input
								type="text"
								id="city"
								value={data.city}
								maxLength="255"
								disabled={inProcess}
								onKeyPress={e => this.props.handleKeyPress(e)}
								onChange={e => this.props.handleInputChange(e)}
							/>
						</div>
						<div className="form-field half-field">
							<label>Postal</label>

							{!!errors.postal && <ErrorWrap animate={1}>{errors.postal}</ErrorWrap>}
							<input
								type="text"
								id="postal"
								value={data.postal}
								maxLength="9"
								disabled={inProcess}
								onKeyPress={e => this.props.handleKeyPress(e)}
								onChange={event => this.props.handleInputChange(event)}
							/>
						</div>
					</div>

					{locationsError ? (
						<ErrorWrap>{locationsError}</ErrorWrap>
					) : locationsLoading ? (
						<GeneralLoader />
					) : (
						<div className="floated-field-container">
							<div className="form-field half-field">
								<label htmlFor="province">Province:</label>

								{!!errors.province && (
									<ErrorWrap animate={1}>{errors.province}</ErrorWrap>
								)}

								<Select
									classNamePrefix="react-select"
									placeholder={"Select one"}
									isClearable={false}
									isDisabled={inProcess}
									name={`province`}
									value={provinces.filter(
										({ abbreviation }) => abbreviation === data.province
									)}
									onChange={({ abbreviation }) => {
										this.props.updateSelectedValue(abbreviation, "province");
									}}
									options={provinces}
									getOptionLabel={({ name }) => name}
									getOptionValue={({ abbreviation }) => abbreviation}
								/>
							</div>
						</div>
					)}
				</div>
			</div>
		);
	}
}

export default LocationFieldset;



// WEBPACK FOOTER //
// ./src/components/admin/organizations/form-components/LocationFieldset.js